// extracted by mini-css-extract-plugin
export default {"standards":"standards_standards__IrtoB","left":"standards_left__MlFGz","right":"standards_right__sCRBw"};